import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

/**
 * DataGrid `baseCheckbox` slot: header select-all shows a minus and clears when
 * anything is selected (partial or all); selects all only when nothing is selected.
 * Row checkboxes unchanged. Preserves MUI's label wrapping so the columns panel shows column names.
 */
export const GridSelectAllAwareCheckbox = React.forwardRef(function GridSelectAllAwareCheckbox(props, ref) {
  const {
    slotProps,
    onChange,
    indeterminate,
    checked,
    material,
    label,
    fullWidth,
    density,
    autoFocus: _autoFocus,
    className,
    ...other
  } = props;
  const isSelectAll = slotProps?.htmlInput?.name === 'select_all_rows';
  const hasSelection = Boolean(indeterminate || checked);
  const handleChange = (event) => {
    if (isSelectAll && hasSelection) {
      onChange?.({ ...event, target: { ...event.target, checked: false } });
      return;
    }
    onChange?.(event);
  };
  const checkbox = (
    <Checkbox
      {...other}
      {...material}
      ref={ref}
      className={label ? material?.className : className}
      checked={isSelectAll ? false : checked}
      indeterminate={isSelectAll ? hasSelection : indeterminate}
      inputProps={slotProps?.htmlInput}
      onChange={handleChange}
      sx={density === 'compact' ? { p: 0.5, ...material?.sx } : material?.sx}
    />
  );
  if (!label) {
    return checkbox;
  }
  return (
    <FormControlLabel
      className={className}
      control={checkbox}
      label={label}
      sx={{
        m: 0,
        gap: 0.5,
        overflow: 'hidden',
        ...(fullWidth && { width: '100%' }),
        '& .MuiFormControlLabel-label': {
          fontSize: '0.875rem',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        },
      }}
    />
  );
});

/** Merge slots while defaulting `baseCheckbox` to GridSelectAllAwareCheckbox. */
export const withSelectAllAwareCheckbox = (slots = {}) => ({
  ...slots,
  baseCheckbox: slots.baseCheckbox ?? GridSelectAllAwareCheckbox,
});
